// extracted by mini-css-extract-plugin
export default {"container":"Assist_container__+mAxt","darkmode":"Assist_darkmode__vVAcH"};